import { forwardRef, useCallback, useMemo, useState } from "react";
import { Form } from "antd";
import { nameRegexValidator, urlRegexValidator, FieldTypes } from "utils/formUtils";
import ToolsIntegrationsAPI from "restAPI/ToolsIntegrationAPI";
import message from "components/CustomMessage";
import BaseModalForm from "components/BaseModalForm";
import _ from "lodash";
import { duplicateNameValidator } from "utils/validatorUtil";
import ModalUtil from "utils/modalUtil";
import DeviceTypesForm from "./DeviceTypesForm";

export default forwardRef(function ArmisModalForm(
  { configData, name = "Armis Centrix", afterClose, ...props },
  ref
) {
  const [form] = Form.useForm();
  const [loginId, setLoginId] = useState(configData?.id);
  const { configList } = props;

  const addCreds = useCallback(async () => {
    const data = form.getFieldsValue();
    const api = loginId
      ? ToolsIntegrationsAPI.updateGenericLoginDetail(data, name, loginId)
      : ToolsIntegrationsAPI.postGenericLoginDetail(data, name);
    const response = await api.promise;
    setLoginId(response.id);
    message.success(
      loginId ? "Credentials updated successfully" : "Credentials added successfully"
    );
    ModalUtil.show({
      content: (
        <DeviceTypesForm
          loginData={data}
          loginId={response.id}
          name={name}
          configData={configData}
          onUpdateConfigComponent={props.onUpdateConfigComponent}
        />
      ),
    });
  }, [form, name, loginId, configData, props]);

  const fields = useMemo(
    () => [
      {
        name: "name",
        label: "Configuration Name",
        NoDefaultLengthRule: true,
        rules: [nameRegexValidator, duplicateNameValidator({ list: configList })],
        props: { autoFocus: true },
        required: true,
      },
      {
        name: "apiEndpoint",
        label: "API Endpoint",
        required: true,
        rules: [urlRegexValidator],
      },
      {
        name: "apiSecretKey",
        label: "API Secret Key",
        type: FieldTypes.PASSWORD,
        required: true,
      },
    ],
    [configList]
  );

  return (
    <BaseModalForm
      title={!_.isEmpty(configData) ? `Edit ${name} Configuration` : `Configure ${name}`}
      ref={ref}
      form={form}
      fields={fields}
      onOk={addCreds}
      initialValues={configData || { apiEndpoint: "https://integration-partner.armis.com" }}
      afterClose={afterClose}
    />
  );
});

